import { GenericRule } from '../../../../../../utils/genericValidator.util';
import { OfflineOrder } from '../../OfflineOrder';

export class ValidateOrderProductsPriceTableRule implements GenericRule<OfflineOrder> {
  validateOrThrow(order: OfflineOrder) {
    const anyOrderProductWithDifferentPriceTable = order.products?.some(
      (product) => product.metadata.productColorPriceInfo.priceTableId !== order.priceTable.id,
    );

    if (anyOrderProductWithDifferentPriceTable) {
      throw new Error('price table is not the same for all products');
    }
  }
}
